import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let weigthValue;
addEventListener('setVitalSignWeigthValue', (e) => {
    const ce = e;
    weigthValue = ce.detail.weigthValue;
});
export const VITAL_SIGN_WEIGHT_VALUE_VALIDATOR = 'vital-sign-weight-value-validator';
async function vitalSignWeightValueValidator(value) {
    let valid = false;
    let message = '';
    if (weigthValue && weigthValue > 0) {
        valid = (value && value.cd) ? true : false;
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = MessageService.translate('message.unity-referring-patient-measurement');
    }
    weigthValue = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_WEIGHT_VALUE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignWeightValueValidator;
//# sourceMappingURL=vital-sign-weight-measure-unit-validator.js.map